import React, { useState } from 'react';
import { checkMot } from '../../../../../ressources/functionJS/checkMot';
import * as s from '../../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './FormulaireAxe.module.scss';

const FormulaireAxe = ({
  preConfigAxe,
  gererConfigAxe,
  axisKey,
  axisName,
  disabled,
  children,
}) => {
  const [title, setTitle] = useState(preConfigAxe.title || '');
  const [range, setRange] = useState([
    preConfigAxe.range?.[0] ?? null,
    preConfigAxe.range?.[1] ?? null,
  ]);

  const gererMinAxe = (event) => {
    const value = parseFloat(event.target.value);
    const newMin = isNaN(value) ? null : value;
    setRange([newMin, range[1]]);
    gererConfigAxe(axisKey, {
      ...preConfigAxe,
      range: [newMin, preConfigAxe.range[1]],
    });
  };

  const gererMaxAxe = (event) => {
    const value = parseFloat(event.target.value);
    const newMax = isNaN(value) ? null : value;
    setRange([range[0], newMax]);
    gererConfigAxe(axisKey, {
      ...preConfigAxe,
      range: [preConfigAxe.range[0], newMax],
    });
  };

  const gererEtatDeCibleName = (event) => {
    const { name, value } = event.target;
    setTitle(value);
    gererConfigAxe(axisKey, {
      ...preConfigAxe,
      [name]: value,
    });
  };

  let formulairePlageDeLAxe;
  switch (preConfigAxe.type) {
    case 'date':
      // Handle date case if needed
      break;

    case 'linear':
      formulairePlageDeLAxe = (
        <>
          <div className={[styles.style, s.col_12].join(' ')}>
            {checkMot('plage_de')} {axisName}
          </div>
          <div className={s.row}>
            <div className={s.col_6}>
              <input
                type="number"
                className={[s.form_control, styles.input].join(' ')}
                placeholder={
                  range[0] == null ? 'echelle_de_l_axe_gauche_min' : undefined
                }
                disabled={disabled === true}
                value={range[0] ?? ''}
                onChange={gererMinAxe}
              />
            </div>
            <div className={s.col_6}>
              <input
                type="number"
                className={[s.form_control, styles.input].join(' ')}
                placeholder={
                  range[1] == null ? 'echelle_de_l_axe_gauche_max' : undefined
                }
                disabled={disabled === true}
                value={range[1] ?? ''}
                onChange={gererMaxAxe}
              />
            </div>
          </div>
        </>
      );
      break;

    default:
      formulairePlageDeLAxe = (
        <div className={[styles.style, s.text_left].join(' ')}>
          {checkMot('selectionner_un_type_de_courbe')}
        </div>
      );
  }

  return (
    <>
      <div className={[styles.borderr, s.row].join(' ')}>
        <div className={s.col_12}>{axisName}</div>
        <div className={s.col_12}>
          <div className={[styles.styleTitle].join(' ')}>
            {checkMot('titre')}
          </div>
          <input
            type="text"
            className={[s.form_control].join(' ')}
            placeholder="title"
            name="title"
            value={title}
            disabled={disabled === true}
            onChange={gererEtatDeCibleName}
          />
        </div>
        <div className={s.col_12}>{formulairePlageDeLAxe}</div>
        {children}
      </div>
    </>
  );
};

export default FormulaireAxe;
